import {StoichiometryNoteLinkedGroupAdapter} from 'notebook/integrations/chemistry/StoichiometryNoteLinkedGroupAdapter';
import {MixtureNoteLinkedGroupAdapter} from 'notebook/integrations/registry/MixtureNoteLinkedGroupAdapter';
import {NotePartGridNoteLinkedGroupAdapter} from 'notebook/notes/groups/note-part-grid/NotePartGridNoteLinkedGroupAdapter';
import {
  NoteLinkedGroupKind,
  UnknownNoteLinkedGroupAdapter,
} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import lazyInit from 'util/lazyInit';

export const getNoteLinkedGroupAdapters: () => {
  [index in NoteLinkedGroupKind]: UnknownNoteLinkedGroupAdapter;
} = lazyInit(() => ({
  [NoteLinkedGroupKind.MIXTURE_GROUP]: new MixtureNoteLinkedGroupAdapter(NoteLinkedGroupKind.MIXTURE_GROUP),
  [NoteLinkedGroupKind.NOTE_PART_GRID]: new NotePartGridNoteLinkedGroupAdapter(
    NoteLinkedGroupKind.NOTE_PART_GRID
  ),
  [NoteLinkedGroupKind.STOICHIOMETRY_GROUP]: new StoichiometryNoteLinkedGroupAdapter(
    NoteLinkedGroupKind.STOICHIOMETRY_GROUP
  ),
}));

export function isKnownNoteLinkedGroupAdapter(kind: string): boolean {
  return Object.keys(getNoteLinkedGroupAdapters()).includes(kind);
}

export function getMixtureGroupAdapter(): MixtureNoteLinkedGroupAdapter {
  return getNoteLinkedGroupAdapters()[NoteLinkedGroupKind.MIXTURE_GROUP] as MixtureNoteLinkedGroupAdapter;
}

export function getStoichiometryGroupAdapter(): StoichiometryNoteLinkedGroupAdapter {
  return getNoteLinkedGroupAdapters()[
    NoteLinkedGroupKind.STOICHIOMETRY_GROUP
  ] as StoichiometryNoteLinkedGroupAdapter;
}
